import { useCurrentUser } from '@bonusly/who-am-i';

import { EventDTO } from '../lib/entities/event';

export const useCurrentUserRole = (event?: EventDTO) => {
	const user = useCurrentUser();

	if (!event) {
		return {
			role: 'other',
			isGuest: false,
			isHost: false,
			isOther: true,
		};
	}

	let role: 'host' | 'guest' | 'other';

	if (event.hostId === user.id) {
		role = 'host';
	} else if (event.guestId === user.id) {
		role = 'guest';
	} else {
		role = 'other';
	}

	return {
		role,
		isGuest: role === 'guest',
		isHost: role === 'host',
		isOther: role === 'other',
	};
};
